"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("@linaria/react");
var _intents = _interopRequireDefault(require("@ux/intents"));
const intents = new _intents.default();
const CardStyle = /*#__PURE__*/(0, _react.styled)("div")({
  name: "CardStyle",
  class: "c10b7wu7",
  vars: {
    "c10b7wu7-0": [({
      backgroundColor
    }) => backgroundColor || intents.ux.box.backgroundColor],
    "c10b7wu7-1": [({
      textColor
    }) => textColor || 'inherit']
  }
});
var _default = exports.default = CardStyle;